<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="3">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000999') }}</span>
							<el-date-picker
								:value="searchParams.strMt"
								@input="value => setSearchParam({ key: 'strMt', value })"
								type="month"
								:placeholder="getMessage_('QWCC000999')"
								value-format="yyyyMM"
							/>
						</div>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	async created() {
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error.message || error });
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isPqyUser) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				await this.getList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
